import React from 'react';
export function Footer() {
  return <footer className="py-12 md:py-16 border-t border-gray-900" style={{
    backgroundColor: '#1F1A17'
  }} data-id="element-17">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-18">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gray-900 border border-gray-800 text-emerald-500 text-sm font-bold tracking-wider mb-6" data-id="element-19">
          NEXO RECURSOS™
        </div>

        <p className="text-gray-300 font-medium text-base md:text-lg mb-2" data-id="element-20">
          El sistema operativo N°1 para dueños de PyME en Argentina.
        </p>
        <p className="text-gray-500 text-sm md:text-base mb-10" data-id="element-21">
          Porque tener una empresa no debería costarte todos los domingos del
          año.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-sm text-gray-400 mb-10" data-id="element-22">
          <a href="mailto:soportenexorecursos@gmail.com" className="hover:text-emerald-500 transition-colors" data-id="element-23">
            📧 soportenexorecursos@gmail.com
          </a>
          <span className="hidden md:inline text-gray-800" data-id="element-24">|</span>
          <a href="https://www.nexorecursos.com" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-500 transition-colors" data-id="element-25">
            🌐 www.nexorecursos.com
          </a>
        </div>

        <div className="text-gray-600 text-xs md:text-sm space-y-1 mb-12" data-id="element-26">
          <p data-id="element-27">© Nexo Recursos™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-28">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="pt-8 border-t border-gray-900" data-id="element-29">
          <p className="text-gray-500 italic font-medium text-sm md:text-base" data-id="element-30">
            "Tu empresa puede funcionar sin que estés en todo. Ese es el sistema
            que construimos juntos."
          </p>
        </div>
      </div>
    </footer>;
}